import React, { useEffect, useState } from "react";
import "./styles.less";
import { Button } from "../../components/Button";
import { blogAxios } from "../../utils/blogAxios";
import { dateFormat } from "../../utils";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const CustomerHot = () => {
  const { t } = useTranslation();

  const customerData = [
    {
      title: t("customer.cnpn.banner.title"),
      content: t("customer.cnpn.banner.subtitle"),
      cover: "//files.authing.co/authing-website/customer-hot-cnpn.png",
      link: "/customer/cnpn",
    },
    {
      title: t("customer.yuanqi.banner.title"),
      content: t("customer.yuanqi.banner.subtitle"),
      cover: "//files.authing.co/authing-website/customer-hot-yuanqi.png",
      link: "/customer/yuanqi",
    },

    {
      title: t("customer.volkswagen.banner.title"),
      content: t("customer.volkswagen.banner.subtitle"),
      cover: "//files.authing.co/authing-website/customer-hot-volkswagen.png",
      link: "/customer/volkswagen",
    },
  ];
  return (
    <div className="customer-hot">
      <div className="inner">
        <div className="content">
          {customerData.map((item, index) => {
            return (
              <a href={item.link} key={index} className="item">
                <div className="item-image">
                  <img src={item.cover} alt={item.title} />
                </div>
                <div className="item-content-text">
                  <div title={item.title} className="item-title">
                    {item.title}
                  </div>
                  <div title={item.content} className="item-text">
                    {item.content}
                  </div>
                  <div className="item-date">
                    <span className="item-arrow">
                      <i className="icon authing-icon authing-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};
